import { Length, ModelBase, Property, Required, ShortString } from '@skylab-shared/core';

export class CountryModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property(String)
    public externalId: string | null;

    @Property()
    @Length({ max: 2 }, 'data-model.country.validation.code.length')
    @Required('data-model.country.validation.code.non-empty')
    public code: string;

    @Property()
    public default: boolean;

    @Property()
    public euMember: boolean;

    @Property()
    @ShortString('data-model.country.validation.name.length')
    @Required('data-model.country.validation.name.non-empty')
    public name: string;
}
